import { em } from 'polished'
import styled, { css } from 'styled-components'

import FrameMacSide from 'components/FrameMacSide'

export const Cover = styled.div`
  background: ${p => p.theme.colors.purpleHeart};
  display: ${p => (p.isTablet ? 'none' : 'block')};
  height: 100%;
  position: absolute;
  ${p =>
    p.isTablet
      ? css`
          width: 59vw;
          left: 0;
        `
      : css`
          width: 90%;
          right: 0;
        `}

  ${p => p.theme.mq.upMd} {
    display: ${p => (p.isTablet ? 'block' : 'none')};
  }

  ${p => p.theme.mq.upLg} {
    width: 60%;
  }
`

export const Content = styled.div`
  min-height: 0;
  display: flex;
  align-items: center;

  ${p => p.theme.mq.upMd} {
    min-height: ${p => p.theme.blocks.heightMinResultsMd};
  }

  ${p => p.theme.mq.upLg} {
    min-height: ${p => p.theme.blocks.heightMinResultsLg};
  }
`

export const FrameWrapper = styled.div`
  position: relative;
  min-height: ${p => p.theme.blocks.heightMinResults};

  ${p => p.theme.mq.upMd} {
    overflow: hidden;
    width: 59vw;
    margin-left: ${em(-40)};
    padding-left: ${em(40)};
  }

  ${p => p.theme.mq.upLg} {
    width: auto;
    margin-left: 0;
    padding-left: 0;
  }
`

export const IconWrapper = styled.div`
  position: absolute;
  z-index: 4;
  -webkit-backface-visibility: hidden;

  &.pie {
    width: ${em(120)};
    height: ${em(120)};
    top: 0;
    left: 30%;
    transform: translate(-40%, -50%);

    ${p => p.theme.mq.upMd} {
      width: ${em(110)};
      height: ${em(110)};
      transform: translate(0, -140%);
    }

    ${p => p.theme.mq.upLg} {
      width: ${em(150)};
      height: ${em(150)};
      left: 32%;
      transform: translate(0, -100%);
    }
  }

  &.nutrition {
    width: ${em(90)};
    height: ${em(90)};
    bottom: 0;
    left: 5%;
    transform: translate(0, 15%) rotate(30deg);

    ${p => p.theme.mq.upMd} {
      width: ${em(100)};
      height: ${em(100)};
      left: 50%;
      transform: translate(-350%, -50%) rotate(22deg);
    }

    ${p => p.theme.mq.upLg} {
      width: ${em(112)};
      height: ${em(112)};
      left: auto;
      right: 26%;
      transform: translate(-5%, -77%) rotate(22deg);
    }
  }
`

export const FrameMacSideStyled = styled(FrameMacSide)`
  ${p => p.theme.mq.upMd} {
    margin-top: ${em(95)};
  }
  ${p => p.theme.mq.upLg} {
    margin-top: ${em(50)};
  }
`
